<div class="form-page__navigation grid">
  @for (action of actions; track action.action) {
    <button
      type="button"
      class="form-button form-action {{ action.style }}"
      [disabled]="isDisabled(action)"
      (click)="handleAction(action.action)"
      [tabindex]="isDisabled(action) ? -1 : 0"
    >
      {{ action.label | translateInline }}
    </button>
  }
  <ng-content select="button"></ng-content>
</div>
